import React from "react";
import style from "./DataQualityTable.module.scss";
import DataQualityRow, { ChartDataItem } from "./DataQualityRow";

interface DataQualityTableProps {
  chartData: ChartDataItem[];
  tableData: any[];
  setFilteredTableData: React.Dispatch<React.SetStateAction<any[]>>;
  setIsChartSelected: React.Dispatch<React.SetStateAction<boolean>>;
  dataVaultPage?: boolean;
  TypeHeading: string;
}

const DataQualityTable: React.FC<DataQualityTableProps> = ({
  chartData,
  tableData,
  setFilteredTableData,
  setIsChartSelected,
  dataVaultPage,
  TypeHeading
}) => {
  return (
    <div className={style.dataQualityTableWrap}>
      <div className={style.dataQualityHeader}>
        <div className={style.typeHeading}>{TypeHeading}</div>
        <div className={style.statusHeading}>Test Execution Status</div>
      </div>
      <div className={style.dataQualityGraphBody}>
        {chartData.map((dataItem) => (
          <DataQualityRow
            key={dataItem.chartType}
            data={dataItem}
            tableData={tableData}
            setFilteredTableData={setFilteredTableData}
            setIsChartSelected={setIsChartSelected}
            dataVaultPage={dataVaultPage}
          />
        ))}
        {chartData.length === 0 && (
          <div className={style.emptyState}>No Data</div>
        )}
      </div>
    </div>
  );
};

export default DataQualityTable;
